import { useState, useEffect, useCallback } from "react";
import { useLocation, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure } from "@/services/casinoApi";
import CasinoHeading from "../components/common/CasinoHeading";
import VideoBox from "../components/common/VideoBox";
import ResultWorliMatka from "../components/worliMatka/ResultWorliMatka";
import RightSection from "../components/RightSection/RightSection";
import styles from "./WorliMatka.module.css";

function extractCasinoGame(url) {
    const match = url.match(/\/lord-games\/([^/?#]+)/);
    return match ? match[1] : null;
}

export default function WorliMatka() {
    const [gameData, setGameData] = useState([]);
    const [activeTab, setActiveTab] = useState("game");
    const [iframeSrc, setIframeSrc] = useState("");
    const { pathname } = useLocation();
    // const [subData, setSubData] = useState([]); // Used for BetTable, skipping
    const [exposures, setExposures] = useState({});
    const [myBets, setMyBets] = useState([]);

    useEffect(() => {
        const name = extractCasinoGame(pathname) || "worli2"; // Default to worli2 as requested
        setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

        const fetchGameData = async () => {
            try {
                const response = await getCasinoGameDetails(name);
                setGameData(response);
                // const data = response?.data?.data?.sub || [];
                // setSubData(data);
            } catch (err) {
                console.error("Error fetching game data:", err);
            }
        };

        let intervalId = null;
        const initialTimeout = setTimeout(() => {
            fetchGameData();
            intervalId = setInterval(fetchGameData, 1500);
        }, 5000);

        return () => {
            clearTimeout(initialTimeout);
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [pathname]);

    const fetchExposure = useCallback(async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const userId = user?.user_id || user?.id;
            const matchId = gameData?.data?.data?.mid?.toString();

            if (userId && matchId) {
                const response = await getMatchExposure(userId, matchId);
                if (response.success && response.data) {
                    const exposureMap = {};
                    response.data.forEach((item) => {
                        const teamName = item.team_name || item.selection || item.player_name || item.nat || "";
                        const exposureAmount = parseFloat(item.exposure_amount || item.exposure || 0) || 0;
                        if (teamName && exposureAmount !== 0) {
                            exposureMap[teamName] = exposureAmount;
                            exposureMap[teamName.toLowerCase()] = exposureAmount;
                        }
                    });
                    setExposures(exposureMap);
                }
            }
        } catch (error) {
            console.error('Error fetching exposure:', error);
        }
    }, [gameData?.data?.data?.mid]);

    useEffect(() => {
        const matchId = gameData?.data?.data?.mid?.toString();
        if (!matchId) return;

        const timeoutId = setTimeout(() => {
            fetchExposure();
        }, 5000);

        const intervalId = setInterval(() => {
            fetchExposure();
        }, 5000);

        return () => {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
        };
    }, [gameData?.data?.data?.mid, fetchExposure]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <Layout>
            <div className={styles.container}>
                <div className={styles.sectionA}>
                    <CasinoHeading
                        name="WORLI MATKA"
                        roundId={gameData?.data?.data?.mid || "0"}
                        placedBetCount={myBets.length}
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                    />

                    {activeTab === "game" && (
                        <>
                            <VideoBox
                                gameType="worli2"
                                resultData={gameData?.data?.data?.card}
                                iframeSrc={iframeSrc}
                                timerValue={gameData?.data?.data?.lt}
                            />

                            {/* BetTable Skipped */}

                            <div className={styles.heading}>
                                <div>Last Result</div>
                                <Link to="/admin/reports/casinoresult/worli2">
                                    <div className={styles.viewAll}>View All</div>
                                </Link>
                            </div>

                            <ResultWorliMatka
                                data={gameData?.data?.lrs || []}
                                gameData={gameData}
                                gameType="worli2"
                            />

                        </>
                    )}

                    {activeTab === "placedBet" && (
                        <div className="mt-4 p-4 bg-[rgba(0,0,0,0.4)] rounded">
                            <div className="text-white text-center text-xl">Coming Soon</div>
                        </div>
                    )}
                </div>

                <RightSection
                    sectionKey="worli2"
                    data={myBets}
                    title="Matched"
                    viewMoreText="View More"
                    onViewMore={() => {
                        console.log("View more clicked for worli2");
                    }}
                />
            </div>
        </Layout>
    );
}
